/**
 * @generated SignedSource<<bb56e1e6bcabd6407e4fcb2c88f43e6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type starredFiltersList_navigationAppsSidebarCommon$data = {
  readonly favouriteFilters?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename?: string;
        readonly filterId?: string;
        readonly " $fragmentSpreads": FragmentRefs<"filterItem_navigationAppsSidebarCommon">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
  readonly favouriteFiltersOld?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly filterId: string;
        readonly " $fragmentSpreads": FragmentRefs<"filterItem_navigationAppsSidebarCommon">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "starredFiltersList_navigationAppsSidebarCommon";
};
export type starredFiltersList_navigationAppsSidebarCommon$key = {
  readonly " $data"?: starredFiltersList_navigationAppsSidebarCommon$data;
  readonly " $fragmentSpreads": FragmentRefs<"starredFiltersList_navigationAppsSidebarCommon">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v2 = {
  "kind": "FragmentSpread",
  "name": "filterItem_navigationAppsSidebarCommon"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "starredFiltersList_navigationAppsSidebarCommon",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "favouriteFilters",
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "sort": {
                  "order": "DESC"
                },
                "type": "FILTER"
              }
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 15
            }
          ],
          "concreteType": "JiraFavouriteConnection",
          "kind": "LinkedField",
          "name": "favourites",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraFavouriteEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "__typename"
                        },
                        (v1/*: any*/),
                        (v2/*: any*/)
                      ],
                      "type": "JiraFilter",
                      "abstractKey": "__isJiraFilter"
                    }
                  ]
                }
              ]
            },
            {
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "hasNextPage"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "favouriteFiltersOld",
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "JiraFilterConnection",
          "kind": "LinkedField",
          "name": "favouriteFilters",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraFilterEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "900a854eaff0335a83067c20ea0c3e72";

export default node;
